import posthog from "posthog-js";
import { isChunkLoadErrorValue } from "@/lib/chunk-load-recovery";
import { isDocumentLoadStopped } from "@/lib/error-tracking/stopped-document-load";

let interruptionRecorded = false;

export function isInterruptedChunkLoad(value: string, type: string): boolean {
  return isChunkLoadErrorValue(value, type) && isDocumentLoadStopped();
}

export function recordInterruptedChunkLoad(value: string): void {
  if (interruptionRecorded) return;
  interruptionRecorded = true;
  posthog.capture("chunk_load_interrupted", {
    error_message: value.slice(0, 200),
    pathname: window.location.pathname,
  });
}
